<template>
  <div class="park-detail-info-place">
    <!-- <div class="park-detail-info-sub-title">◇位置</div> -->
    <div v-loading="mapLoading" class="park-detail-info-place-content">
      <tz-map
        ref="placeTzMap"
        :position="position"
        container="placeMapView"
        mw="100%"
        mh="100%"
        :maxZoom="18"
      >
        <tz-toggle-map :base-list="configList" :is-note="true" />
      </tz-map>
    </div>
  </div>
</template>
<script>
// 园区位置组件
export default {
  name: "ParkPlace",
  props: {
    parkCodeActual: String,
    parkId: Number,
  },
  data() {
    return {
      position: [100.264162, 25.615269],
      configList: mapConfig.configList,
      mapView: undefined,
      mapLoading: false,
      layerArr: layerConfig.parkDistributionLayer.layerIndex, //园区分布查询layerIndex
      layerIndex: 0, //园区分布查询起始位置
    };
  },
  watch: {
    // parkId(val) {
    //   if (val) {
    //     this.$nextTick(() => {
    //       this.mapView = this.$refs["placeTzMap" + this.parkId].tzApi;
    //       //this.onParkLocation(this.parkCodeActual);
    //       this.parkData();
    //     });
    //   }
    // },
  },
  mounted() {
    this.$nextTick(() => {
      this.mapView = this.$refs["placeTzMap"].tzApi;
      console.log(this.mapView, "this.mapView");
    });
  },
  methods: {
    //查询园区
    parkData() {
      this.mapView.addVectorMultiPolygon(
        [
          [
            [
              [103.32302180940906, 26.42426354462691],
              [103.32320871281189, 26.424005413119346],
              [103.32300751018852, 26.423861819267586],
              [103.32359734763952, 26.42308629879369],
              [103.32299427666459, 26.422713663804586],
              [103.32335669625456, 26.422220036725378],
              [103.32353365315561, 26.421979011222447],
              [103.32296862799984, 26.421402123109544],
              [103.3224009453474, 26.42073901159614],
              [103.32203819660555, 26.420490890442295],
              [103.32178037536409, 26.421026611189234],
              [103.3216048483851, 26.421296608351838],
              [103.3212782478929, 26.42161547197651],
              [103.32055497173462, 26.422323805898998],
              [103.32023769990997, 26.422748098845716],
              [103.31999216610564, 26.423137393775733],
              [103.32021314841813, 26.423266837694428],
              [103.32108804487746, 26.423779314563774],
              [103.32138249370718, 26.423371783181324],
              [103.3213801689597, 26.423376322059653],
              [103.32249595422496, 26.42395347367392],
              [103.32241267070827, 26.4240541239987],
              [103.3227086816604, 26.42421355760962],
              [103.32285411282709, 26.424035772433],
              [103.32301327304418, 26.424164897991716],
              [103.32296717739337, 26.42423019236952],
              [103.32302180940906, 26.42426354462691],
            ],
            [
              [103.31562321194173, 26.42095685167743],
              [103.3160363847714, 26.42026511744126],
              [103.31542745741132, 26.4199189018359],
              [103.31516186243005, 26.420580355898778],
              [103.31445831919615, 26.42029801464173],
              [103.3147407306003, 26.419756805332327],
              [103.3138728011889, 26.419342446296923],
              [103.31410083598485, 26.41900668171303],
              [103.31329663972821, 26.418587552673443],
              [103.31305021919235, 26.41890279562756],
              [103.31206857140751, 26.41838233817441],
              [103.31232232501537, 26.417771872074297],
              [103.31033293022062, 26.41826803524168],
              [103.31077570423543, 26.418834001987648],
              [103.31008078010399, 26.419781974658463],
              [103.3100169021584, 26.4209349612795],
              [103.31003676638375, 26.421231724064853],
              [103.310124363049, 26.421509152325598],
              [103.31027135543877, 26.42175838414215],
              [103.31055819600402, 26.422043919791122],
              [103.31081588324645, 26.422199101407443],
              [103.31552024766137, 26.42443768664998],
              [103.3164992118692, 26.422064034927303],
              [103.31651852211218, 26.421797977694553],
              [103.31524569183529, 26.421316549918913],
              [103.31562321194173, 26.42095685167743],
            ],
            [
              [103.3341427188115, 26.43435007629506],
              [103.33088101804458, 26.434223146880754],
              [103.33085224063848, 26.434322339404503],
              [103.330742828219, 26.43682931202318],
              [103.33159337913122, 26.436871427274582],
              [103.3320640303308, 26.43714776915425],
              [103.33392895625639, 26.437105268093717],
              [103.3341427188115, 26.43435007629506],
            ],
            [
              [103.62456892691449, 26.575735851428476],
              [103.62462497895967, 26.57542304383844],
              [103.62492953437055, 26.57547396255336],
              [103.62526879731718, 26.575524456788287],
              [103.62549442822535, 26.575521712057423],
              [103.62559270344059, 26.575707789882642],
              [103.62565356685866, 26.57571485315799],
              [103.62582548216034, 26.575603516189346],
              [103.6258756724244, 26.575478056267343],
              [103.62586429510122, 26.575298721558795],
              [103.62577588994543, 26.57509928340528],
              [103.62594875133385, 26.575066007590237],
              [103.62602932609258, 26.575044246694688],
              [103.62602369543725, 26.57467026092388],
              [103.62596606058531, 26.57391246069153],
              [103.62597136208876, 26.573496779652714],
              [103.62583223067298, 26.57346730167467],
              [103.62578569795164, 26.573447087613033],
              [103.62575758604385, 26.573114935605872],
              [103.62587016677486, 26.572916147662113],
              [103.62612139868367, 26.572727496876553],
              [103.62617123821212, 26.57269007428755],
              [103.62651781714362, 26.572140699134025],
              [103.62617173283928, 26.571966845793327],
              [103.62612139328775, 26.571959000107825],
              [103.62604727386264, 26.57194744741679],
              [103.62561833232024, 26.571811588633977],
              [103.62555726205807, 26.571461181288555],
              [103.62540136008477, 26.571483142732916],
              [103.62538115771434, 26.571623849760897],
              [103.62529129565684, 26.57158481109019],
              [103.62506848232465, 26.571578194777942],
              [103.62508969643238, 26.571223467988716],
              [103.62509674711725, 26.57082504673855],
              [103.62489512181247, 26.570619219801188],
              [103.62458950430226, 26.570382940920013],
              [103.62447636958882, 26.570333792070926],
              [103.6241891665968, 26.57038781074891],
              [103.62327496976411, 26.570483501312594],
              [103.62323340579712, 26.570361532558707],
              [103.62303760540124, 26.569953393234584],
              [103.62261241133376, 26.56923857430081],
              [103.62232047610917, 26.568509502011977],
              [103.6221327579205, 26.567703375810197],
              [103.62194342994542, 26.566789902032383],
              [103.62211863226912, 26.56676251317947],
              [103.62202762177736, 26.56631520568226],
              [103.62192588507162, 26.56608907744902],
              [103.62192124187186, 26.56577966659836],
              [103.62205135218824, 26.56577238029115],
              [103.62204803998515, 26.565759054137118],
              [103.62204752017698, 26.56575695511941],
              [103.62207118134, 26.565389349139195],
              [103.62185682882966, 26.565365714955817],
              [103.621832523752, 26.56504241857283],
              [103.62167678635467, 26.56503556483949],
              [103.62167610556787, 26.564990230015155],
              [103.62076976791053, 26.56524297098639],
              [103.62077212233567, 26.566478554941398],
              [103.6185381542125, 26.56714057108053],
              [103.61849842486248, 26.56779401668058],
              [103.61800228957406, 26.567791281842233],
              [103.61800255127679, 26.567808770958038],
              [103.61798070674428, 26.5682987953532],
              [103.61801538460236, 26.56866569176833],
              [103.61797801867067, 26.56941827413408],
              [103.61797067660552, 26.56995103701081],
              [103.61810329692969, 26.570156139993912],
              [103.61835226344624, 26.57049559629479],
              [103.61866816560342, 26.57082292613717],
              [103.61907799385438, 26.571396280813758],
              [103.61910098861978, 26.57208115592067],
              [103.61920564722288, 26.572879990419267],
              [103.61939921190418, 26.57335265520095],
              [103.61954450727325, 26.573334841429812],
              [103.61946971335664, 26.573536896610563],
              [103.61926902964206, 26.573637053207506],
              [103.61903203130328, 26.57377822698362],
              [103.61915571956087, 26.573955103845037],
              [103.6192647030037, 26.574292469222144],
              [103.6192831202199, 26.574654292561604],
              [103.61925941858738, 26.574806405691106],
              [103.61925554610661, 26.574862621412876],
              [103.61938744427522, 26.574797029359445],
              [103.61944202323087, 26.574779934146704],
              [103.61948368972054, 26.57477238703609],
              [103.61959395020068, 26.574816525762117],
              [103.61968764157149, 26.575311737446782],
              [103.61973443329754, 26.57589303673433],
              [103.61978855809554, 26.576328779849348],
              [103.62069439393122, 26.576319816306523],
              [103.62071363042975, 26.576226842594735],
              [103.62089005673079, 26.575794621224816],
              [103.62092922400456, 26.57559175485568],
              [103.62085451912083, 26.575301722596464],
              [103.62058734762803, 26.57477310829239],
              [103.62041042759921, 26.57442305617917],
              [103.62028065992456, 26.574200464080207],
              [103.6200560677334, 26.573815213401417],
              [103.61988201204525, 26.573314906158032],
              [103.6199475258577, 26.57331141498986],
              [103.61995830693036, 26.573265240198737],
              [103.62000420473032, 26.573243615100807],
              [103.6203551561656, 26.5739036923016],
              [103.62046677821928, 26.574115881942475],
              [103.62053994616167, 26.574254974687392],
              [103.62065930418362, 26.574481878136226],
              [103.62092125061531, 26.575060572987127],
              [103.62102763861469, 26.575479252365653],
              [103.62107795568318, 26.575532938294543],
              [103.62119179186777, 26.5755070630006],
              [103.62119297177827, 26.5754269208158],
              [103.6212337983012, 26.57530448801174],
              [103.62128452905785, 26.575172836257423],
              [103.62135459703711, 26.575053282183262],
              [103.62142975068252, 26.574967091158385],
              [103.62155731232019, 26.57484678255304],
              [103.62155370513943, 26.574583558184713],
              [103.62143754870397, 26.574209595796276],
              [103.62138297064763, 26.573989615328514],
              [103.62134687815598, 26.57374259494486],
              [103.62131152760497, 26.573569747945555],
              [103.62126092635071, 26.57330431394297],
              [103.62122439858717, 26.573054907657934],
              [103.62115484861744, 26.572954573894492],
              [103.62111990725799, 26.572898513755433],
              [103.6212776303584, 26.572856200653177],
              [103.6213739459509, 26.572836251891545],
              [103.62143917917484, 26.572833114156936],
              [103.62157513508447, 26.572844769370647],
              [103.62218891068972, 26.572912443354653],
              [103.62235646427945, 26.572941710891314],
              [103.6223827289798, 26.572942914184182],
              [103.62235721791131, 26.573531033930124],
              [103.62234618862578, 26.573952538079197],
              [103.62238711137616, 26.574365610184827],
              [103.6225252499404, 26.574894543748258],
              [103.62263302019778, 26.575135131281343],
              [103.62282663164382, 26.575312252758295],
              [103.62324388110028, 26.57535400198566],
              [103.6233924643908, 26.575422423306236],
              [103.62363321919776, 26.575848668681147],
              [103.62376913823522, 26.576229370589033],
              [103.62379689581013, 26.576783444700254],
              [103.62383023907432, 26.57682946930464],
              [103.62399394986096, 26.57674944762897],
              [103.62437262020035, 26.576534158924346],
              [103.62434183280942, 26.576442625027198],
              [103.62420928083372, 26.57604850883166],
              [103.62418181463909, 26.575966851289195],
              [103.62410899023774, 26.575741446110897],
              [103.62456892691449, 26.575735851428476],
            ],
            [
              [103.61399201382045, 26.57930915469376],
              [103.61403087172744, 26.579257932008034],
              [103.61386914664388, 26.579279322382888],
              [103.61384198801738, 26.5791444537536],
              [103.61447635809753, 26.578855120267633],
              [103.6144962232222, 26.57888479519721],
              [103.61454339536147, 26.57842265698008],
              [103.61456199244208, 26.578240451635565],
              [103.61463857960683, 26.577835632608412],
              [103.61494729168425, 26.577695195377032],
              [103.61532391696528, 26.577479368877846],
              [103.61565189611815, 26.577239278669822],
              [103.6157544350192, 26.57716347481454],
              [103.61581439821595, 26.577013624379333],
              [103.6159127552695, 26.57665825817213],
              [103.61597178676863, 26.5764462816706],
              [103.61598300311317, 26.576272163929275],
              [103.61611470343087, 26.575835617719633],
              [103.6163084992379, 26.575392108958738],
              [103.61646297218846, 26.575091988104816],
              [103.61667328494423, 26.57482847055752],
              [103.61685669807821, 26.574614988590895],
              [103.61689713789264, 26.574546148186243],
              [103.61675753703076, 26.57445463317481],
              [103.61563439531113, 26.573759878115936],
              [103.61512530708734, 26.573455356879265],
              [103.61511545591361, 26.572796833706946],
              [103.61516637013193, 26.57250418082333],
              [103.6152456705513, 26.572338430374316],
              [103.61534055172513, 26.572135471374963],
              [103.61536735691806, 26.57207922417689],
              [103.61535920276503, 26.57204929833648],
              [103.6152090096881, 26.57214269922622],
              [103.61480746419318, 26.57241944040493],
              [103.61450030524497, 26.57259557082898],
              [103.61447895084297, 26.572613196641782],
              [103.61415785510098, 26.57287822864737],
              [103.6140268949253, 26.572999175771372],
              [103.61376388009904, 26.5731681403974],
              [103.61358698525123, 26.573176907888012],
              [103.61326199994141, 26.573147677223574],
              [103.61290622993863, 26.573032612565044],
              [103.61281814224355, 26.573009711329178],
              [103.61267771310605, 26.573042002386558],
              [103.61262079321511, 26.573181950386754],
              [103.61261559603298, 26.573327904059568],
              [103.6126572220532, 26.57364570468559],
              [103.61263697921328, 26.573771946118484],
              [103.61252843733757, 26.573912513751566],
              [103.6123692600334, 26.574120009830665],
              [103.61221745357267, 26.574503862962956],
              [103.61206745295067, 26.574935914360992],
              [103.61196328267943, 26.57535086604969],
              [103.6118644283008, 26.575500992576792],
              [103.61182944107588, 26.575617250635673],
              [103.61184005757264, 26.575708137920287],
              [103.61188694912346, 26.575765488586455],
              [103.61188965698216, 26.575939208827492],
              [103.61195584798406, 26.576054245606997],
              [103.6120123272072, 26.576136303347766],
              [103.61202384302601, 26.5762850961803],
              [103.61195111305346, 26.576442570168524],
              [103.61187455376768, 26.576429672991082],
              [103.61158063823592, 26.576741843861043],
              [103.61139735730228, 26.576886149076586],
              [103.61108750398517, 26.57706137298402],
              [103.61331617240347, 26.579871091577672],
              [103.61353741282142, 26.579880842926627],
              [103.61363938335091, 26.57977397738722],
              [103.61399201382045, 26.57930915469376],
            ],
          ],
        ],
        attributes["开发区名称"] || attributes["产业园名称"],
        { id: "park" },
        "#0000ff80",
        "#0000ff80",
        "#0e1d93",
        "#fff"
      );
      return;
      this.mapView.queryArcGISRestByAttribute(
        layerConfig.parkDistributionLayer.url,
        this.layerArr[this.layerIndex],
        `产业园代码 = '${this.parkCodeActual}'`,
        (res) => {
          if (res.features && res.features.length) {
            let { geometry, attributes } = res.features[0];
            if (geometry) {
              let zb = geometry.rings;
              //居中地图范围
              let extent = this.mapView.getPolygonExtent(zb);
              this.mapView.zoomToExtent(
                extent[0],
                extent[1],
                extent[2],
                extent[3]
              );
              this.mapView.addVectorMultiPolygon(
                [geometry.rings],
                attributes["开发区名称"] || attributes["产业园名称"],
                { id: "park" },
                "#0000ff80",
                "#0000ff80",
                "#0e1d93",
                "#fff"
              );
            }
          } else {
            if (this.layerIndex < this.layerArr.length) {
              this.layerIndex++;
              this.parkData();
            } else {
              console.log("没有找到对应园区位置");
            }
          }
        }
      );
    },
    //园区定位
    onParkLocation(code) {
      this.mapLoading = true;
      layerConfig.layerArr.forEach((item) => {
        this.mapView.queryArcGISRestByAttribute(
          item.url,
          item.layerIndex,
          `${item.fields} = '${code}'`,
          (res) => {
            this.mapLoading = false;
            if (res.features && res.features.length) {
              let { attributes, geometry } = res.features[0];
              if (geometry) {
                this.mapView.removeVectorFeatureById("kfq_layer");
                let extent = this.mapView.getMultiPolygonExtent([
                  geometry.rings,
                ]);
                this.mapView.zoomToExtent(
                  extent[0],
                  extent[1],
                  extent[2],
                  extent[3]
                );
                this.mapView.addVectorMultiPolygon(
                  [geometry.rings],
                  attributes[item.title],
                  { id: "kfq_layer" },
                  "#04ebf0",
                  "rgba(0,0,0,0)",
                  "#ffffff",
                  "#04ebf0",
                  undefined,
                  undefined,
                  4
                );
              }
            }
          }
        );
      });
    },
  },
};
</script>
<style scoped>
.park-detail-info-sub-title {
  /* margin-top: 20px; */
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.park-detail-info-place-content {
  width: calc(100% - 2px);
  height: 450px;
  border: 1px solid #eee;
}
</style>
